
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("67eiR", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CHANNEL", () => $b91664ea2c5e46dd$export$d821aa4c8afb384e);
$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $b91664ea2c5e46dd$export$af8124aa496797f2);
const $b91664ea2c5e46dd$export$d821aa4c8afb384e = 'fabric-elements';
const $b91664ea2c5e46dd$export$af8124aa496797f2 = '_|unknown|_';

});

parcelRegister("4codo", function(module, exports) {
$parcel$export(module.exports, "isRestricted", () => $d71eac02ed1a6430$export$dbaa15dc1820b89a);

var $eBfRL = parcelRequire("eBfRL");
function $d71eac02ed1a6430$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === (0, $eBfRL.UserAccessLevel)[(0, $eBfRL.UserAccessLevel).NONE];
}

});

parcelRegister("a6LHe", function(module, exports) {
$parcel$export(module.exports, "UnknownUserError", () => $f02213b86878e88a$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $f02213b86878e88a$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $f02213b86878e88a$export$da9f8ce14593162f);
parcelRequire("bSJIT");

var $4lLOO = parcelRequire("4lLOO");

var $cHAOs = parcelRequire("cHAOs");
const $f02213b86878e88a$export$98e06fe7a6174253 = (0, $cHAOs.propFormatter)((0, $4lLOO.messages).unknownUserError);
const $f02213b86878e88a$export$58bd5a2057b6b855 = (0, $cHAOs.propFormatter)((0, $4lLOO.messages).noAccessWarning);
const $f02213b86878e88a$export$da9f8ce14593162f = (0, $cHAOs.propFormatter)((0, $4lLOO.messages).noAccessLabel);
const $f02213b86878e88a$export$4a258ffee7316766 = (0, $cHAOs.propFormatter)((0, $4lLOO.messages).defaultHeadline);
const $f02213b86878e88a$export$702321a50d74536e = (0, $cHAOs.propFormatter)((0, $4lLOO.messages).defaultAdvisedAction);
const $f02213b86878e88a$export$ed7f16088a93ae9d = (0, $cHAOs.propFormatter)((0, $4lLOO.messages).loginAgain);
const $f02213b86878e88a$export$3ab158df56460d1c = (0, $cHAOs.propFormatter)((0, $4lLOO.messages).differentText);

});
parcelRegister("4lLOO", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f4621d5eb23cd50b$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $f4621d5eb23cd50b$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Accessible label shown next to the no-access icon on a mention, indicating the mentioned user does not have access to the current content.'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    },
    loadingPlaceholder: {
        id: 'fabric.elements.mentions.loading.placeholder',
        defaultMessage: 'Loading',
        description: 'Accessible label for a loading placeholder row shown in the mention list while a slower mention source (such as agents) is still loading.'
    }
});

});

parcelRegister("cHAOs", function(module, exports) {
$parcel$export(module.exports, "propFormatter", () => $cbac6bf326c05892$export$392a0c6a82ab0e50);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");
const $cbac6bf326c05892$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $4vLTk.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
            values: values,
            ...messageDescriptor
        });
    };

});


parcelRegister("5Xh9u", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdedabd640044310$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dTM5i = parcelRequire("dTM5i");
var $4vLTk = parcelRequire("4vLTk");

var $1RwF3 = parcelRequire("1RwF3");
const $bdedabd640044310$var$EMPTY = {};
const $bdedabd640044310$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState($bdedabd640044310$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        let aborted = false;
        setMessages($bdedabd640044310$var$EMPTY);
        (0, $1RwF3.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $bdedabd640044310$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $4vLTk.default)();
    const messages = $bdedabd640044310$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dTM5i.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $bdedabd640044310$export$2e2bcd8739ae039 = $bdedabd640044310$var$MessagesIntlProvider;

});
parcelRegister("1RwF3", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $5b7aaf53c0099b29$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $5b7aaf53c0099b29$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("l4PNX")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("vwfXB")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("8cTQI")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("j4kBR")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("fjijq")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("e0uEy")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("ksy9k")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("5fgnX")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("jgV1q")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("1IeSd")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("j21CD")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("6GWOj")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("8eXlP")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("dROYA")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("5BnyX")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("iLR0c")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("kiidA")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("gx3f1")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("f3Pzj")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("l99ay")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("jPzv0")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("6whqS")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("fVVeb")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("9RUf4")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("jdhoU")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("aMnu9")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("kYoyM")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6cDwe")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("547If")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("516hU")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $5b7aaf53c0099b29$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("j4kBR")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("l4PNX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fGzBN").then(()=>parcelRequire('9i7wq'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});



parcelRegister("vwfXB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fIJXM").then(()=>parcelRequire('je9wK'));

});

parcelRegister("8cTQI", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jMCf9").then(()=>parcelRequire('fHd7C'));

});

parcelRegister("j4kBR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("agtqB").then(()=>parcelRequire('i2Czb'));

});

parcelRegister("fjijq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9T30f").then(()=>parcelRequire('dccmQ'));

});

parcelRegister("e0uEy", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("FbPhf").then(()=>parcelRequire('cGTDz'));

});

parcelRegister("ksy9k", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("khBK4").then(()=>parcelRequire('jJlQM'));

});

parcelRegister("5fgnX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("e95Ad").then(()=>parcelRequire('llvE5'));

});

parcelRegister("jgV1q", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5Xr4g").then(()=>parcelRequire('6AUlZ'));

});

parcelRegister("1IeSd", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kWoyr").then(()=>parcelRequire('6ZrbJ'));

});

parcelRegister("j21CD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("eTq1p").then(()=>parcelRequire('jaIce'));

});

parcelRegister("6GWOj", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7Fhj6").then(()=>parcelRequire('2pFpM'));

});

parcelRegister("8eXlP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8TtxN").then(()=>parcelRequire('hHRTx'));

});

parcelRegister("dROYA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7kQl3").then(()=>parcelRequire('lpk0y'));

});

parcelRegister("5BnyX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gRuZZ").then(()=>parcelRequire('g4l6W'));

});

parcelRegister("iLR0c", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iw9oZ").then(()=>parcelRequire('dKan5'));

});

parcelRegister("kiidA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jGS5V").then(()=>parcelRequire('dJ5dl'));

});

parcelRegister("gx3f1", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("b450E").then(()=>parcelRequire('3nash'));

});

parcelRegister("f3Pzj", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kwgVZ").then(()=>parcelRequire('kC6KG'));

});

parcelRegister("l99ay", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jAOYp").then(()=>parcelRequire('9m40t'));

});

parcelRegister("jPzv0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bZF45").then(()=>parcelRequire('50gxN'));

});

parcelRegister("6whqS", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("izjBH").then(()=>parcelRequire('1Kc2t'));

});

parcelRegister("fVVeb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ie0Of").then(()=>parcelRequire('cnzNQ'));

});

parcelRegister("9RUf4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8mGuH").then(()=>parcelRequire('ikEDq'));

});

parcelRegister("jdhoU", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hTTLV").then(()=>parcelRequire('2uHqv'));

});

parcelRegister("aMnu9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jHekW").then(()=>parcelRequire('2p1UK'));

});

parcelRegister("kYoyM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("030wL").then(()=>parcelRequire('fSiJW'));

});

parcelRegister("6cDwe", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gPtTV").then(()=>parcelRequire('6lvvn'));

});

parcelRegister("547If", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5HjtL").then(()=>parcelRequire('ceWtu'));

});

parcelRegister("516hU", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("d4bv2").then(()=>parcelRequire('c5fH9'));

});



parcelRegister("cER38", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d66c842830b62e6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

const $1d66c842830b62e6$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>(parcelRequire("1wzG9")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $1d66c842830b62e6$export$2e2bcd8739ae039 = $1d66c842830b62e6$var$AsyncNoAccessTooltip;

});
parcelRegister("1wzG9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9GN0N").then(()=>parcelRequire('9I04M'));

});


parcelRegister("3qSID", function(module, exports) {
$parcel$export(module.exports, "navigateToTeamsApp", () => $fcf2d334e4ca3a68$export$cd99a4ca8e852372);

var $5MueY = parcelRequire("5MueY");

var $cJ8VG = parcelRequire("cJ8VG");

var $hRcMb = parcelRequire("hRcMb");

var $35cTO = parcelRequire("35cTO");
const $fcf2d334e4ca3a68$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
     * Default to opening in a new tab.
     */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? false : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $cJ8VG.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $hRcMb.getPathAndQuery)(actionWithDefaults);
    const href = (0, $5MueY.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $35cTO.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};

});
parcelRegister("5MueY", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $5db3ea6803dbd582$export$82476f982757e71e);

var $kGVK0 = parcelRequire("kGVK0");
function $5db3ea6803dbd582$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    return (0, $kGVK0.generateTeamsAppPath)(path, config, query, anchor);
}

});
parcelRegister("kGVK0", function(module, exports) {
$parcel$export(module.exports, "generateTeamsAppPath", () => $bb64259e1092bbd6$export$9665cb78fbba2c92);

var $akFQf = parcelRequire("akFQf");

var $dLOrv = parcelRequire("dLOrv");

var $9hihM = parcelRequire("9hihM");

var $7190A = parcelRequire("7190A");

var $eimym = parcelRequire("eimym");

var $046Eo = parcelRequire("046Eo");
function $bb64259e1092bbd6$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $9hihM.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${(0, $046Eo.isFedRampStaging)() ? '.stg' : ''}.atlassian-us-gov-mod.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    if ((0, $7190A.isIsolatedCloud)()) return `${(0, $dLOrv.getUrlForDomainInContext)('home', (0, $eimym.getEnvironment)())}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    return `${(0, $akFQf.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}

});
parcelRegister("akFQf", function(module, exports) {
$parcel$export(module.exports, "getATLContextUrl", () => $4fee414b41eadcc5$export$45d6512913ef41b4);

var $a7bUp = parcelRequire("a7bUp");
function $4fee414b41eadcc5$export$45d6512913ef41b4(domain) {
    var _globalThis$location;
    return `${((_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.protocol) ?? 'https:'}//${(0, $a7bUp.getATLContextDomain)(domain)}`;
}

});

parcelRegister("eimym", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $92378373fd703910$export$57570b1603cf6adb);

var $c9wRy = parcelRequire("c9wRy");
const $92378373fd703910$export$57570b1603cf6adb = ()=>{
    var _browserDocument$quer;
    const browserDocument = (0, $c9wRy.getDocument)();
    // @ts-expect-error
    return (browserDocument === null || browserDocument === void 0 || (_browserDocument$quer = browserDocument.querySelector('meta[name=ajs-environment]')) === null || _browserDocument$quer === void 0 ? void 0 : _browserDocument$quer.content) === 'staging' ? 'staging' : 'prod';
};

});

parcelRegister("046Eo", function(module, exports) {
$parcel$export(module.exports, "isFedRampStaging", () => $2f1cf3e158315ed6$export$a9f2c34176fff494);

var $585aL = parcelRequire("585aL");
function $2f1cf3e158315ed6$export$a9f2c34176fff494() {
    const host = (0, $585aL.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    // *.atlassian-stg-fedm.net
    if (host.match(/atlassian-stg-fedm\.net/)) return true;
    return false;
}

});
parcelRegister("585aL", function(module, exports) {
$parcel$export(module.exports, "hostname", () => $ec4d4217676a5131$export$640106f6dc7d2706);
const $ec4d4217676a5131$export$640106f6dc7d2706 = ()=>{
    var _globalThis$location;
    return (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
};

});




parcelRegister("cJ8VG", function(module, exports) {
$parcel$export(module.exports, "getHostProductFromPath", () => $34670c8638acb3a1$export$a792d22ca73cc3ca);

var $585aL = parcelRequire("585aL");

var $b1uEM = parcelRequire("b1uEM");
function $34670c8638acb3a1$export$a792d22ca73cc3ca() {
    const path = (0, $b1uEM.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $585aL.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("b1uEM", function(module, exports) {
$parcel$export(module.exports, "pathname", () => $18d68139b33307bc$export$7333db99aa99d383);
const $18d68139b33307bc$export$7333db99aa99d383 = ()=>{
    var _globalThis$location;
    return (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.pathname;
};

});


parcelRegister("hRcMb", function(module, exports) {
$parcel$export(module.exports, "getPathAndQuery", () => $515709c1c0f9942d$export$b406f12e2156b3fe);
function $515709c1c0f9942d$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $515709c1c0f9942d$export$b406f12e2156b3fe(action) {
    var _action$payload, _action$payload2, _action$payload3, _action$payload4;
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.userId)) return {
                path: ''
            };
            return {
                path: `${$515709c1c0f9942d$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!((_action$payload2 = action.payload) !== null && _action$payload2 !== void 0 && _action$payload2.teamId)) return {
                path: ''
            };
            return {
                path: `team/${$515709c1c0f9942d$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!((_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && _action$payload3.agentId)) return {
                path: ''
            };
            return {
                path: `agent/${$515709c1c0f9942d$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!((_action$payload4 = action.payload) !== null && _action$payload4 !== void 0 && _action$payload4.kudosId)) return {
                path: ''
            };
            return {
                path: `kudos/${$515709c1c0f9942d$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_PEOPLE'
                })
            };
        case 'USER_WORK':
            return {
                path: `${$515709c1c0f9942d$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}

});

parcelRegister("35cTO", function(module, exports) {
$parcel$export(module.exports, "onNavigateBase", () => $85c423e9cf1a219e$export$39f25014273b0a58);

var $fGGWZ = parcelRequire("fGGWZ");

var $lyc9e = parcelRequire("lyc9e");
const $85c423e9cf1a219e$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if (config.shouldOpenInSameTab) {
            (0, $lyc9e.redirect)(href);
            return;
        }
        (0, $fGGWZ.openInNewTab)(href);
    };

});
parcelRegister("fGGWZ", function(module, exports) {
$parcel$export(module.exports, "openInNewTab", () => $89b3b2533bf8ac3c$export$9e52b10d57ddf9e3);
const $89b3b2533bf8ac3c$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');

});

parcelRegister("lyc9e", function(module, exports) {
$parcel$export(module.exports, "redirect", () => $9160dd0e1a4427c1$export$89e12c5b50f7529d);
function $9160dd0e1a4427c1$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}

});



parcelRegister("8wbIC", function(module, exports) {
$parcel$export(module.exports, "ProfileCardLazy", () => $21735d05ef2e2f08$export$403d297463f226af);

var $bSJIT = parcelRequire("bSJIT");

const $21735d05ef2e2f08$export$403d297463f226af = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("hakD4")));

});
parcelRegister("hakD4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("f80Rt"),
    $kOunM("fY58D"),
    $kOunM("3M7DB"),
    $kOunM("kxKmf")
]).then(()=>parcelRequire('dFrF5'));

});



//# sourceMappingURL=shared.58e4608f.js.map
